/**
 * Created by andrey on 16.05.2025
 */

const PortalYandexAds = function () {
    AdsPlugin.call(this, connector.PORTAL_YANDEX_ADS, {
        cantLoadAndPlayInParallel: true,
        cantLoadAfterPlay: true
    });
};

PortalYandexAds.prototype = Object.create(AdsPlugin.prototype);
PortalYandexAds.prototype.constructor = PortalYandexAds;

PortalYandexAds.isAppropriate = function () {
    return connector.utils.isIFrame()
        && (connector.platform.oneOf(connector.CLEVERAPPS) && connector._countryManager.country === "RU"
        || connector.platform.oneOf(connector.LABSYSTECH));
};

PortalYandexAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

PortalYandexAds.prototype._connect = function (callback) {
    connector.platform.callNative("YandexAds.connect", () => {
        callback(connector.STATUS_CONNECTED);
    });
};

PortalYandexAds.prototype._playAd = function (name, ad, callback) {
    connector.platform.callNative("YandexAds.play", { name }, callback);
};
